import { Box } from '@fhs-legacy/universal-components';

export const Container = Box.withConfig({
  textAlign: 'center',
  overflow: 'hidden',
});
